import { render, staticRenderFns } from "./WhoWeAreMobile.vue?vue&type=template&id=703631c6&scoped=true&"
import script from "./WhoWeAreMobile.vue?vue&type=script&lang=js&"
export * from "./WhoWeAreMobile.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeAreMobile.vue?vue&type=style&index=0&id=703631c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703631c6",
  null
  
)

export default component.exports